module.exports = __webpack_public_path__ + "static/img/20003 (5).283cc78.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20003 (5).webp
// module id = 7GFl
// module chunks = 14